import cx from "classnames";

import { MSSLink } from "components/common/link";
import SagesureLogoIcon from "images/sagesure-logo-icon.svg?react";
import SagesureLogoInverse from "images/sagesure-logo-inverse.svg?react";
import SagesureLogo from "images/sagesure-logo.svg?react";
import { trackEvent } from "utils";

import styles from "./logo-link.module.scss";

type LogoImageLinkProps = {
  className?: string;
  onClick?: () => null;
};

const LogoImageLink = ({ className, onClick }: LogoImageLinkProps) => {
  return (
    <MSSLink
      to="/"
      className={cx(styles.logoLink, className)}
      onClick={onClick}
    >
      <img
        src={"/assets/images/sagesure-logo.svg?react"}
        width="222px"
        height="54px"
        alt="SageSure logo"
      />
    </MSSLink>
  );
};

const LOGO_MAP = {
  default: <SagesureLogo width="116" />,
  mobile: <SagesureLogo height="28" />,
  mobileInverse: <SagesureLogoInverse height="28" />,
  icon: <SagesureLogoIcon width="33" />,
};

type HeaderLogoProps = {
  logo?: keyof typeof LOGO_MAP;
};

const HeaderLogo = ({ logo = "default" }: HeaderLogoProps) => {
  return (
    <MSSLink
      to="/"
      className={cx(styles.logoLink, styles.headerLogo)}
      onClick={() => trackEvent("Home")}
      title="SageSure Logo"
    >
      {LOGO_MAP[logo]}
    </MSSLink>
  );
};

export { HeaderLogo, LogoImageLink };
